import { I18n } from 'i18n-js'

const { locale } = window.I18n



const translations = {"en":{"navigation":{"select":"Please select …"},"errors":{"file_invalid":"Invalid file format.","file_corrupted":"File corrupted."}},"de":{"navigation":{"select":"Bitte auswählen …"},"errors":{"file_invalid":"Ungültiges Dateiformat.","file_corrupted":"Datei beschädigt."}}}
const i18n = new I18n(translations)

i18n.defaultLocale = "de"
i18n.locale = locale

export default i18n
